import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_INCOMING_OUTGOING_FILTERS,
  DEFAULT_TEMP_ASSIGNMENT_DATE_TYPE_FILTER,
  DEFAULT_TEMP_ASSIGNMENT_SORT_MODEL,
  DEFAULT_TEMP_ASSIGNMENT_STATUS_FILTERS,
} from "../../util/taed/filterTempAssignments";

const initialState = {
  dateTypeFilter: DEFAULT_TEMP_ASSIGNMENT_DATE_TYPE_FILTER,
  startDateFilter: null,
  endDateFilter: null,
  incomingOutgoingFilters: DEFAULT_INCOMING_OUTGOING_FILTERS,
  statusFilters: DEFAULT_TEMP_ASSIGNMENT_STATUS_FILTERS,
  searchString: "",
  tempAssignmentFoundByReferenceNumberSearch: null,
  tempAssignmentFoundByReferenceNumberSearchIsLoading: false,
  tempAssignmentFoundByReferenceNumberSearchIsDialogOpen: false,
  searchStringErrors: "",
  startDateFilterErrors: "",
  endDateFilterErrors: "",
  sortModel: DEFAULT_TEMP_ASSIGNMENT_SORT_MODEL,
};

export const tempAssignmentSlice = createSlice({
  name: "tempAssignment",
  initialState,
  reducers: {
    updateDateTypeFilter: (state, action) => {
      state.dateTypeFilter = action.payload;
    },
    updateStartDateFilter: (state, action) => {
      state.startDateFilter = action.payload;
    },
    updateEndDateFilter: (state, action) => {
      state.endDateFilter = action.payload;
    },
    updateIncomingOutgoingFilters: (state, action) => {
      state.incomingOutgoingFilters = action.payload;
    },
    updateStatusFilters: (state, action) => {
      state.statusFilters = action.payload;
    },
    updateSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    updateTempAssignmentFoundByReferenceNumberSearch: (state, action) => {
      state.tempAssignmentFoundByReferenceNumberSearch = action.payload;
    },
    updateTempAssignmentFoundByReferenceNumberSearchIsLoading: (state, action) => {
      state.tempAssignmentFoundByReferenceNumberSearchIsLoading = action.payload;
    },
    updateTempAssignmentFoundByReferenceNumberSearchIsDialogOpen: (state, action) => {
      state.tempAssignmentFoundByReferenceNumberSearchIsDialogOpen = action.payload;
    },
    updateSearchStringErrors: (state, action) => {
      state.searchStringErrors = action.payload;
    },
    updateStartDateFilterErrors: (state, action) => {
      state.startDateFilterErrors = action.payload;
    },
    updateEndDateFilterErrors: (state, action) => {
      state.endDateFilterErrors = action.payload;
    },
    updateSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    clearAllTempAssignmentFilters: () => initialState,
  },
});

export const {
  updateDateTypeFilter,
  updateStartDateFilter,
  updateEndDateFilter,
  updateIncomingOutgoingFilters,
  updateStatusFilters,
  updateSearchString,
  updateTempAssignmentFoundByReferenceNumberSearch,
  updateTempAssignmentFoundByReferenceNumberSearchIsLoading,
  updateTempAssignmentFoundByReferenceNumberSearchIsDialogOpen,
  updateSearchStringErrors,
  updateStartDateFilterErrors,
  updateEndDateFilterErrors,
  updateSortModel,
  clearAllTempAssignmentFilters,
} = tempAssignmentSlice.actions;

export const selectTempAssignmentData = (state) => state.tempAssignment;

export default tempAssignmentSlice.reducer;
